import { render } from "./NhlGameCard.vue?vue&type=template&id=d0b8be20&scoped=true"
import script from "./NhlGameCard.vue?vue&type=script&lang=js"
export * from "./NhlGameCard.vue?vue&type=script&lang=js"

import "./NhlGameCard.vue?vue&type=style&index=0&id=d0b8be20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b8be20"]])

export default __exports__